import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import ScheduleService from "../services/ScheduleService";

export const ScheduleContext = createContext("ScheduleContext");

const ScheduleContextProvider = ({children}) => {

    const [scheduleList, setScheduleList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingScheduleList, setLoadingScheduleList] = useState(false);

    const getScheduleList = async (id, params) => {
        try {
            setLoadingScheduleList(true);
            const response = await ScheduleService.getScheduleList(id, params);
            setScheduleList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoadingScheduleList(false);
        } catch (error) {
            setLoadingScheduleList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
        }

    }

    return (
        <ScheduleContext.Provider
            value={{
                getScheduleList,
                scheduleList,
                totalElements,
                loadingScheduleList,
            }}
        >
            {children}
        </ScheduleContext.Provider>
    );
}

export default ScheduleContextProvider;
